import React, { useCallback, useState } from 'react';
import { Gift, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { PriceDisplay } from './ui';
import { motion, AnimatePresence } from 'framer-motion';
const bonuses = [{
  id: 'B1',
  title: 'Plan de Alimentación Anti-Constipación',
  desc: <>
        <strong data-id="element-11">Sin complicaciones</strong>, pensado para lo que hay en{' '}
        <em data-id="element-12">cualquier heladera argentina</em>.
      </>,
  value: '8.000',
  image: 'https://cdn.magicpatterns.com/uploads/dgDv2EvzzVRYjGkMqBLmyY/252bd609512ac0a9_2_-_copia_800x800.webp'
}, {
  id: 'B2',
  title: 'Recetas Prácticas Para Mejorar el Tránsito Intestinal',
  desc: <>
        Recetas <strong data-id="element-13">fáciles, ricas y que los chicos realmente comen</strong>
        , <em data-id="element-14">sin que tu hijo sepa que le estás "ayudando"</em>.
      </>,
  value: '6.000',
  image: 'https://cdn.magicpatterns.com/uploads/jjL5prBTRNQC1J5kYS2qDP/252bd609512ac0a9_3_-_copia_800x800.webp'
}, {
  id: 'B3',
  title: 'Checklist Semanal de Hábitos Intestinales',
  desc: <>
        Una planilla lista para imprimir y pegar en la heladera.{' '}
        <strong data-id="element-15">Seguí el progreso semana a semana</strong>, celebrá los avances
        y sabe{' '}
        <span className="underline decoration-gray-300 decoration-2 underline-offset-2" data-id="element-16">
          exactamente cuándo preocuparte
        </span>{' '}
        (y cuándo no).
      </>,
  value: '4.000',
  image: 'https://cdn.magicpatterns.com/uploads/h717enSqkXhs2p7xyvKuwj/252bd609512ac0a9_5_800x800.webp'
}, {
  id: 'B4',
  title: 'Mitos y Verdades Sobre La Caca Infantil',
  desc: <>
        Las 20 creencias más comunes que circulan entre mamás, abuelas y grupos
        de WhatsApp — y la <strong data-id="element-17">verdad detrás de cada una</strong>.{' '}
        <em data-id="element-18">Deja de hacer cosas que no sirven</em> (o que empeoran la
        situación).
      </>,
  value: '5.000',
  image: 'https://cdn.magicpatterns.com/uploads/mReFsPxUrYLUhpwtCNGdMu/252bd609512ac0a9_4_800x800.webp'
}];
const slideVariants = {
  enter: (direction: number) => ({
    x: direction > 0 ? 300 : -300,
    opacity: 0
  }),
  center: {
    x: 0,
    opacity: 1
  },
  exit: (direction: number) => ({
    x: direction > 0 ? -300 : 300,
    opacity: 0
  })
};
export const Bonuses = () => {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(0);
  const goTo = useCallback((index: number) => {
    setDirection(index > current ? 1 : -1);
    setCurrent(index);
  }, [current]);
  const prev = useCallback(() => {
    setDirection(-1);
    setCurrent(c => c === 0 ? bonuses.length - 1 : c - 1);
  }, []);
  const next = useCallback(() => {
    setDirection(1);
    setCurrent(c => c === bonuses.length - 1 ? 0 : c + 1);
  }, []);
  const bonus = bonuses[current];
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-19">
      <div className="max-w-4xl mx-auto" data-id="element-20">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-21">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-brand-gold/10 rounded-full mb-3" data-id="element-22">
            <Gift className="w-8 h-8 text-brand-gold" data-id="element-23" />
          </div>
          <h2 className="font-nunito font-extrabold text-3xl md:text-4xl text-brand-charcoal leading-tight" data-id="element-24">
            Si Comprás Hoy, También Recibís Estos{' '}
            <br className="hidden md:block" data-id="element-25" />
            <span className="text-brand-gold" data-id="element-26">4 Bonos Exclusivos:</span>
          </h2>
          <p className="text-lg text-gray-600 mt-4 font-medium" data-id="element-27">
            Estos bonos se incluyen GRATIS solo durante el lanzamiento.
          </p>
        </div>

        {/* Carousel */}
        <div className="relative" data-id="element-28">
          {/* Navigation Arrows */}
          <button onClick={prev} className="absolute left-0 md:-left-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-white rounded-full shadow-lg border border-gray-200 flex items-center justify-center hover:bg-gray-50 hover:shadow-xl transition-all active:scale-95" aria-label="Bono anterior" data-id="element-29">
            <ChevronLeftIcon className="w-6 h-6 text-brand-charcoal" data-id="element-30" />
          </button>

          <button onClick={next} className="absolute right-0 md:-right-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 bg-white rounded-full shadow-lg border border-gray-200 flex items-center justify-center hover:bg-gray-50 hover:shadow-xl transition-all active:scale-95" aria-label="Siguiente bono" data-id="element-31">
            <ChevronRightIcon className="w-6 h-6 text-brand-charcoal" data-id="element-32" />
          </button>

          {/* Slide Area */}
          <div className="overflow-hidden rounded-3xl border-2 border-brand-gold/20 bg-gradient-to-br from-white to-amber-50/30 shadow-md mx-8 md:mx-0" data-id="element-33">
            <AnimatePresence mode="wait" custom={direction} data-id="element-34">
              <motion.div key={current} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
              duration: 0.35,
              ease: 'easeInOut'
            }} className="flex flex-col items-center px-4 py-6 md:px-16 md:py-12" data-id="element-35">
                {/* Bonus Number Badge */}
                <div className="absolute top-4 right-4 bg-brand-gold text-white font-bold text-xs py-1.5 px-4 rounded-full uppercase tracking-wider shadow-sm" data-id="element-36">
                  Bono {current + 1} de {bonuses.length}
                </div>

                {/* Cover Image */}
                <div className="w-full max-w-[200px] md:max-w-[320px] mx-auto mb-4 md:mb-8" data-id="element-37">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-auto rounded-xl drop-shadow-xl" data-id="element-38" />
                </div>

                {/* Title */}
                <h3 className="font-nunito font-bold text-2xl md:text-3xl text-brand-charcoal text-center mb-2 leading-tight" data-id="element-39">
                  {bonus.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 text-lg text-center max-w-lg mb-3 md:mb-6 leading-relaxed" data-id="element-40">
                  {bonus.desc}
                </p>

                {/* Price */}
                <div className="flex items-center gap-3" data-id="element-41">
                  <span className="text-gray-400 text-lg line-through" data-id="element-42">
                    <PriceDisplay amount={bonus.value} data-id="element-43" />
                  </span>
                  <span className="bg-brand-gold text-white font-nunito font-extrabold text-xl px-5 py-2 rounded-full shadow-sm uppercase tracking-wide" data-id="element-44">
                    ¡GRATIS!
                  </span>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Dot Indicators */}
          <div className="flex items-center justify-center gap-3 mt-5" data-id="element-45">
            {bonuses.map((b, i) => <button key={b.id} onClick={() => goTo(i)} aria-label={`Ver bono ${i + 1}`} className={`transition-all duration-300 rounded-full ${i === current ? 'w-10 h-3 bg-brand-gold' : 'w-3 h-3 bg-gray-300 hover:bg-brand-gold/50'}`} data-id="element-46" />)}
          </div>
        </div>
      </div>
    </section>;
};